/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useEffect, useState } from "react";
import { openlightbox } from "../../util/Functions";
import DataTable from "react-data-table-component";
import * as Modals from "../modals";
import { ThemeProvider } from "@mui/material/styles";
import { theme, customStyles2 } from "../../util/TableStyles"
import { useStyles } from "../../util/ComponentStyles";
import { Paper, Typography } from "@mui/material";
import { Email } from "@mui/icons-material";
import { noDataComponent } from "../../util/DataObject"

const ConcentratorMessages = (props) => {
  const clasess = useStyles();
  const [data, setData] = useState([]);

  useEffect(() => {
    if (props.next === "update") {
      props.updateNext(null);
    }
    setData(props.widgets[0].data.content);
  }, [props.next]);

  const messageJson = async (item) => {
    let contentModal = {
      title: "Tracking ID " + item.tracking_key,
      content: item,
    };
    props.changeLoader(true);
    const as = (
      <Modals.MessageJson
        changeAlert={props.changeAlert}
        changeLoader={props.changeLoader}
        contentModal={contentModal}
        key="messageJson"
      />
    );
    openlightbox(as);

    props.changeLoader(false);
  };

  const columns = [
    { selector: (row) => row.tracking_key, name: "Tracking Key", minWidth: "34%", wrap: true, sortable: true },
    { selector: (row) => row.status, name: "Estatus", maxWidth: "16%", wrap: true, sortable: true },
    { selector: (row) => row.type, name: "Tipo", minWidth: "22%", sortable: true },
    { selector: (row) => row.amount, name: "Monto", maxWidth: "20%", sortable: true },
    {
      sortable: true, maxWidth: "8%",
      cell: (item) => {
        return (
          <div>
            <i className="ibon-info tap inb2 col-2"  onClick={() => messageJson(item)} />
          </div>
        );
      },
    },
  ];

  return (
    <Paper className={clasess.aqlDetail}>
      <Typography
        component="div"
        children={
          <div className={clasess.titleTable}>
            <h2 className={clasess.titleH2}>
              <Email className={clasess.iconTitle} />
              Concentradora de Mensajes
            </h2>
          </div>
        }
      />

      <div style={{ width: "96%", margin: "auto" }}>
        <ThemeProvider theme={theme}>
          <DataTable
            columns={columns}
            data={data}
            customStyles={customStyles2}
            noDataComponent={noDataComponent}
          />
        </ThemeProvider>
      </div>
    </Paper>
  );
};

export default ConcentratorMessages;
